<template>
    <component :is="componentType" :to="toCalc" :href="hrefCalc" :title="article.title" class="clean" :target="target">
        <div class="uk-card uk-card-default uk-box-shadow-hover-large card-article uk-margin-bottom">
            <div class="uk-grid uk-flex" uk-grid>
                <div class="uk-width-1-2@s uk-width-1-3@m" v-if="article.image && article.image.small">
                    <div class="ar4x3 uk-background-cover" v-bind:style="{ backgroundImage: `url(${article.image.small})` }" :alt="article.title"></div>
                </div>
                <div class="uk-width-1-2@s uk-width-2-3@m">
                    <div class="uk-card-body uk-text-left" v-bind:class="{ 'uk-padding' : !(article.image && article.image.small) }">
                        <h3 class="uk-card-title"><b>{{article.title}}</b></h3>
                        <p class="summary">{{moment(article.created).format("MM/DD/YYYY")}} <span v-if="article.source"> | {{article.source}}</span></p>

                        <span class="uk-button theme-button button-green">{{ buttonLabel || 'Read More' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </component>
</template>

<script>

export default {
    inject: ['moment'],
    props: ['article', 'buttonLabel'],
    computed: {
        isExternal() {
            return this.article.link.indexOf('//')!==-1
        },
        target() {
            return  this.isExternal ? '_blank' : false
        },
        toCalc() {
            return !this.isExternal ? this.article.link : false
        },
        hrefCalc() {
            return this.isExternal ? this.article.link : false
        },
        componentType() {
            return this.isExternal ? "a" : "router-link"
        }
    }
}
</script>
